import { Grid, useMediaQuery, useTheme } from '@mui/material';
import {
  AdvancedControls,
  PageControlDropdown,
  PageControlSearchInput,
  PageControlsWrapper
} from '../../../../../ui/components/pure/page-controls/page-controls.context';
import { useHasPermissions } from '../../../../../core/permissions/has-permissions.hook';
import { TeamMembersListControlsState } from '../../../team.queries';
import { Paths, ProjectPathParams } from '../../../../../app/router/app.router';
import { ActionButtonSingle } from '../../../../../ui/components/pure/action-button-single/action-button-single.component';
import { TeamMembersListActions, useTeamMembersList } from '../../hooks/use-team-members-list.hook';
import _ from 'lodash';

interface TeamMembersListControlsProps {
  params: ProjectPathParams<Paths.team>;
  formData: TeamMembersListControlsState;
  setFormData: (update: Partial<TeamMembersListControlsState>) => void;
  actions: ReturnType<typeof useTeamMembersList>['actions'];
  statusOptions: { label: string; value: string }[];
}

export function TeamMembersListControls({
  params,
  formData,
  setFormData,
  actions,
  statusOptions
}: TeamMembersListControlsProps) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const showInviteButton = useHasPermissions([{ action: 'projects:InviteTeamMember', projectID: params.projectID }]);

  return (
    <PageControlsWrapper form={formData} onFormInput={setFormData}>
      <Grid
        container
        spacing={isSmallScreen ? 2 : 1}
        sx={{
          justifyContent: isSmallScreen ? 'flex-start' : 'flex-start',
          flexDirection: isSmallScreen ? 'column' : 'row-reverse'
        }}
      >
        <Grid>
          <Grid container spacing={1}>
            <Grid size="grow">
              <PageControlSearchInput name="searchTerm" placeholder="Search" fullWidth />
            </Grid>
            {showInviteButton.hasAllPermissions ? (
              <Grid>
                <ActionButtonSingle
                  onClick={() => actions.setAction(TeamMembersListActions.INVITE_TEAM_MEMBER)}
                  Icon={undefined}
                  label={'Invite User'}
                  style={{ padding: '3px 24px' }}
                />
              </Grid>
            ) : null}
          </Grid>
        </Grid>

        <Grid>
          <AdvancedControls hasActiveInputs={!_.isEmpty(formData.status)} advancedBreakpoint="sm">
            <PageControlDropdown name="status" placeholder="Status" menuItems={statusOptions} />
          </AdvancedControls>
        </Grid>
      </Grid>
    </PageControlsWrapper>
  );
}
